import React, { useEffect } from "react";
import { message } from "antd";
import { useLocation } from "react-router-dom";
import { useGlobal } from "../contexts/GlobalContext";
import request from "../utils/request";
import { persistToken } from "../utils/auth";
import { useTranslation } from "../i18n";

const GitHubCallback: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { API_BASE_URL, setToken, token } = useGlobal();

  useEffect(() => {
    const handleGitHubCallback = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const code = params.get("code");

        console.log("GitHub Callback executing with code:", code);

        if (!code) {
          message.error(t("oauth.noCode"));
          window.location.replace("/console/login");
          return;
        }

        // 准备请求头
        const headers: Record<string, string> = {
          "Content-Type": "application/json",
        };

        // 如果已登录，添加 Authorization 头
        if (token) {
          headers["Authorization"] = `Bearer ${token}`;
        }

        console.log("Sending request to:", `${API_BASE_URL}/api/v3/auth/github`);

        const response = await request.get(`${API_BASE_URL}/api/v3/auth/github`, {
          params: { code },
          headers,
        });

        console.log("Response received:", response);

        if (response.data.code === 200) {
          if (response.data.data?.token) {
            // 登录成功的情况
            persistToken(response.data.data.token, setToken);
            message.success(t("oauth.loginSuccess", { provider: "GitHub" }));
            window.location.replace("/console");
          } else {
            // 绑定成功的情况
            message.success(response.data.msg || t("oauth.bindSuccess", { provider: "GitHub" }));
            window.location.replace("/console/settings");
          }
        } else {
          message.error(response.data.msg || t("oauth.opFailed", { provider: "GitHub" }));
          window.location.replace(
            token ? "/console/settings" : "/console/login"
          );
        }
      } catch (error) {
        console.error("GitHub操作错误:", error);
        message.error(t("oauth.opFailedRetry", { provider: "GitHub" }));
        window.location.replace(token ? "/console/settings" : "/console/login");
      }
    };

    handleGitHubCallback();
  }, [location.search, API_BASE_URL, setToken, token, t]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontSize: "16px",
      }}
    >
      {t("oauth.processing", { provider: "GitHub" })}
    </div>
  );
};

export default GitHubCallback;
